import { useQuery } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { EstimateChatMessage } from "@rebuild/shared/models";
import { INTERNAL_VIEW_POLL_MS, useIsInternalChatView } from "./internalView";
import { ESTIMATE_CHAT_KEYS } from "./queryKeys";

const { estimateChatControllerGetMessages } = getRebuildAPI();

// organizationId is the estimate's org; see useEstimateChatsQuery.
export function useEstimateChatMessagesQuery(estimateId: string, organizationId: string | undefined, chatId: string | undefined) {
  const isInternalView = useIsInternalChatView(organizationId);
  return useQuery({
    queryKey: ESTIMATE_CHAT_KEYS.messages(estimateId, chatId ?? ""),
    queryFn: async (): Promise<EstimateChatMessage[]> => {
      const { messages } = await estimateChatControllerGetMessages(estimateId, chatId!, { overrideOrganizationId: organizationId! });
      return messages;
    },
    enabled: !!chatId && !!organizationId,
    // A just-created chat is selected with a seeded empty cache. Without a stale window React
    // Query still refetches on mount, and that guaranteed-empty result clobbers the optimistic
    // first message.
    staleTime: 30_000,
    refetchInterval: isInternalView ? INTERNAL_VIEW_POLL_MS : false,
  });
}
